AddPageSwapTrigger(function () {
  var input = document.getElementById('brandSearch');
  if (!input) return;

  // Dubbele listeners voorkomen
  var isBound = input.dataset ? input.dataset.brandSearchBound === '1' : input.getAttribute('data-brand-search-bound') === '1';
  if (isBound) return;
  if (input.dataset) { input.dataset.brandSearchBound = '1'; }
  else { input.setAttribute('data-brand-search-bound', '1'); }

  var handler = function () {
    var filter = (input.value || '').toLowerCase();

    // Alle links tonen/verbergen + bijbehorende <br>
    var links = document.querySelectorAll('.row-allemerken a');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var text = ((link.textContent || '') + ' ' + (link.title || '')).toLowerCase();
      var match = text.indexOf(filter) !== -1;
      link.style.display = match ? '' : 'none';

      var next = link.nextElementSibling;
      if (next && next.tagName === 'BR') {
        next.style.display = match ? '' : 'none';
      }
    }

    // Binnenkolommen tonen/verbergen
    var cols = document.querySelectorAll('.row-allemerken .col-xs-6.col-sm-12');
    for (var j = 0; j < cols.length; j++) {
      var col = cols[j];
      var anchors = col.querySelectorAll('a');
      var hasVisible = false;
      for (var a = 0; a < anchors.length; a++) {
        if (anchors[a].style.display !== 'none') { hasVisible = true; break; }
      }
      col.style.display = hasVisible ? '' : 'none';
    }

    // Blokken tonen/verbergen op basis van zichtbare kolommen
    var blocks = document.querySelectorAll('.row-allemerken .col-xs-12.col-sm-3.col-md-3');
    for (var b = 0; b < blocks.length; b++) {
      var block = blocks[b];
      var innerCols = block.querySelectorAll('.col-xs-6.col-sm-12');
      var hasVisibleCol = false;
      for (var c = 0; c < innerCols.length; c++) {
        if (innerCols[c].style.display !== 'none') { hasVisibleCol = true; break; }
      }
      block.style.display = hasVisibleCol ? '' : 'none';
    }
  };

  input.addEventListener('input', handler);
  handler();
});
